import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
    
  width: 100%;
  min-height: 100vh; /* Full viewport height */
  display: flex;
  align-items: stretch;
    padding-bottom: 200px;
    
    iframe {
        width: 100%;
        min-height: 100vh;
        border: none;
    }
`;

export default function EmbeddedPageSection({ embed }) {
    return (
        embed && <Container className="container_small" dangerouslySetInnerHTML={{__html: embed}}/>
    );
}
